"use client";

import { useState } from "react";
import Icon from "@/components/ui/AppIcon";
import { useLanguage } from "@/context/LanguageContext";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { t } = useLanguage();

  const faqs = [
    { id: "faq_age", questionKey: "faq_q1" as const, answerKey: "faq_a1" as const },
    { id: "faq_experience", questionKey: "faq_q2" as const, answerKey: "faq_a2" as const },
    { id: "faq_what_to_bring", questionKey: "faq_q3" as const, answerKey: "faq_a3" as const },
    { id: "faq_weather", questionKey: "faq_q4" as const, answerKey: "faq_a4" as const },
    { id: "faq_cancellation", questionKey: "faq_q5" as const, answerKey: "faq_a5" as const },
    { id: "faq_pickup", questionKey: "faq_q6" as const, answerKey: "faq_a6" as const },
    { id: "faq_group", questionKey: "faq_q7" as const, answerKey: "faq_a7" as const },
    { id: "faq_payment", questionKey: "faq_q8" as const, answerKey: "faq_a8" as const },
  ];

  return (
    <section className="py-20 md:py-32 bg-background">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12 reveal will-animate">
          <span className="text-accent font-semibold text-sm uppercase tracking-wider">
            {t("faq_badge")}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mt-4 mb-6">
            {t("faq_title")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t("faq_desc")}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto space-y-4 reveal will-animate">
          {faqs?.map((faq, index) => (
            <div key={faq?.id} className="bg-card rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-muted/30 transition-colors"
              >
                <span className="font-semibold text-foreground pr-4">
                  {t(faq.questionKey)}
                </span>
                <Icon
                  name="ChevronDownIcon"
                  size={24}
                  className={`text-muted-foreground flex-shrink-0 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}
                />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? "max-h-96" : "max-h-0"}`}>
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {t(faq.answerKey)}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still Have Questions */}
        <div className="text-center mt-12 reveal will-animate">
          <p className="text-muted-foreground mb-4">{t("faq_still")}</p>
          <a
            href="https://wa.me/21654604948"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 bg-success text-white rounded-full font-semibold hover:bg-success/90 transition-all hover:scale-105"
          >
            <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
            <span>{t("faq_chat")}</span>
          </a>
        </div>
      </div>
    </section>
  );
}